import { FormControlLabel, Switch } from "@mui/material";
import { useThemeContext } from "App";
import React from "react";

export default function ModeSwitch({...props}) {

  const themeContext = useThemeContext();

  return (
    <FormControlLabel control={(
      <Switch 
        {...props}
        onChange={themeContext.toggleTheme}
      />
    )} label="Dark Mode" />
  );

}
